// extracted by mini-css-extract-plugin
export var addButton = "_fm-0";
export var border = "_fm-8";
export var check = "_fm-h";
export var danger = "_fm-6";
export var dropdownContainer = "_fm-1";
export var editModalBody = "_fm-j";
export var footerContainer = "_fm-i";
export var fullWidth = "_fm-a";
export var hide = "_fm-9";
export var icon = "_fm-3";
export var input = "_fm-7";
export var inputFlex = "_fm-b";
export var inputWrapper = "_fm-c";
export var manualFocus = "_fm-5";
export var optionButton = "_fm-4";
export var pillWrapper = "_fm-e";
export var pointer = "_fm-2";
export var showOverflow = "_fm-f";
export var tagsFlex = "_fm-d";
export var xButton = "_fm-g";